module.exports = __webpack_public_path__ + "hinted-Montserrat-MediumItalic.fb8ed62a80995155c2c7.eot";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-MediumItalic.eot
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-MediumItalic.eot
// module chunks = 1